import { createFileRoute } from '@tanstack/react-router'
import StudentTimetable from '../../components/studentPage/StudentTimetable'

export const Route = createFileRoute('/student/timetable')({
  component: StudentTimetable,
})
